module.exports = {
	"description": "Dropdown provides a list of actions to the user.",
	"methods": [
		{
			"name": "getItems",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "onTriggerKeyDown",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "onOpen",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "onClose",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "isControlled",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "getItemProps",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "props",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				},
				{
					"name": "scope",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "itemOnClick",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "item",
					"type": {
						"name": "signature",
						"type": "object",
						"raw": "{\n  iconEnd?: React$Element<*>,\n  iconStart?: React$Element<*>,\n  disabled?: boolean,\n  divider?: boolean,\n  onClick?: (event: Object) => void,\n  render?: (item: Object, props: Object, theme: Object) => React$Element<*>,\n  secondaryText?: MnrlReactNode,\n  text?: MnrlReactNode,\n  variant?: 'regular' | 'danger' | 'success' | 'warning'\n}",
						"signature": {
							"properties": [
								{
									"key": "iconEnd",
									"value": {
										"name": "React$Element",
										"elements": [
											{
												"name": "unknown"
											}
										],
										"raw": "React$Element<*>",
										"required": false
									}
								},
								{
									"key": "iconStart",
									"value": {
										"name": "React$Element",
										"elements": [
											{
												"name": "unknown"
											}
										],
										"raw": "React$Element<*>",
										"required": false
									}
								},
								{
									"key": "disabled",
									"value": {
										"name": "boolean",
										"required": false
									}
								},
								{
									"key": "divider",
									"value": {
										"name": "boolean",
										"required": false
									}
								},
								{
									"key": "onClick",
									"value": {
										"name": "signature",
										"type": "function",
										"raw": "(event: Object) => void",
										"signature": {
											"arguments": [
												{
													"name": "event",
													"type": {
														"name": "Object"
													}
												}
											],
											"return": {
												"name": "void"
											}
										},
										"required": false
									}
								},
								{
									"key": "render",
									"value": {
										"name": "signature",
										"type": "function",
										"raw": "(item: Object, props: Object, theme: Object) => React$Element<*>",
										"signature": {
											"arguments": [
												{
													"name": "item",
													"type": {
														"name": "Object"
													}
												},
												{
													"name": "props",
													"type": {
														"name": "Object"
													}
												},
												{
													"name": "theme",
													"type": {
														"name": "Object"
													}
												}
											],
											"return": {
												"name": "React$Element",
												"elements": [
													{
														"name": "unknown"
													}
												],
												"raw": "React$Element<*>"
											}
										},
										"required": false
									}
								},
								{
									"key": "secondaryText",
									"value": {
										"name": "MnrlReactNode",
										"required": false
									}
								},
								{
									"key": "text",
									"value": {
										"name": "MnrlReactNode",
										"required": false
									}
								},
								{
									"key": "variant",
									"value": {
										"name": "union",
										"raw": "'regular' | 'danger' | 'success' | 'warning'",
										"elements": [
											{
												"name": "literal",
												"value": "'regular'"
											},
											{
												"name": "literal",
												"value": "'danger'"
											},
											{
												"name": "literal",
												"value": "'success'"
											},
											{
												"name": "literal",
												"value": "'warning'"
											}
										],
										"required": false
									}
								}
							]
						},
						"alias": "Item"
					}
				},
				{
					"name": "event",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "focusTrigger",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		}
	],
	"props": {
		"children": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": true,
			"description": "Trigger for the Dropdown"
		},
		"defaultIsOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Open the Dropdown immediately upon initialization"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Disable the Dropdown"
		},
		"data": {
			"flowType": {
				"name": "Array",
				"elements": [
					{
						"name": "Object"
					}
				],
				"raw": "Array<Object>"
			},
			"required": true,
			"description": "Data from which the [Menu](./menu#data) will be constructed"
		},
		"isOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "For use with controlled components, in which the app manages Dropdown state"
		},
		"modifiers": {
			"flowType": {
				"name": "Object"
			},
			"required": false,
			"description": "Plugins that are used to alter behavior. See [PopperJS docs](https://popper.js.org/popper-documentation.html#modifiers) for options."
		},
		"onClose": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: Object) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Dropdown is closed"
		},
		"onOpen": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: Object) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Dropdown is opened"
		},
		"placement": {
			"flowType": {
				"name": "union",
				"raw": "| 'bottom-end'\n| 'bottom-start'\n| 'left-end'\n| 'left-start'\n| 'right-end'\n| 'right-start'\n| 'top-end'\n| 'top-start'",
				"elements": [
					{
						"name": "literal",
						"value": "'bottom-end'"
					},
					{
						"name": "literal",
						"value": "'bottom-start'"
					},
					{
						"name": "literal",
						"value": "'left-end'"
					},
					{
						"name": "literal",
						"value": "'left-start'"
					},
					{
						"name": "literal",
						"value": "'right-end'"
					},
					{
						"name": "literal",
						"value": "'right-start'"
					},
					{
						"name": "literal",
						"value": "'top-end'"
					},
					{
						"name": "literal",
						"value": "'top-start'"
					}
				]
			},
			"required": false,
			"description": "Placement of the Dropdown menu",
			"defaultValue": {
				"value": "'bottom-start'",
				"computed": false
			}
		},
		"restoreFocus": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Focus trigger after selecting an item",
			"defaultValue": {
				"value": "true",
				"computed": false
			}
		},
		"wide": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display a wider Dropdown menu"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Dropdown/Dropdown.js
// module id = 1571
// module chunks = 0